import {createAsyncThunk} from "@reduxjs/toolkit";
import {USER_LOCALSTORAGE_KEY} from "shared/const/localstorage";
import axios from "axios";
import {createRequestParams} from "common/hook/create-request-params/createRequestParams";
import {getLessonsTest} from "features/model/service/lessons/lessons-test/get-lessons-test/getLessonsTest";


export const deleteLessonsTest = createAsyncThunk(
    "lessons/testDelete",
    async ({lessonsId, testId}: { lessonsId: string | undefined; testId: number }, thunkAPI) => {
        try {
            const authToken = localStorage.getItem(USER_LOCALSTORAGE_KEY);
            if (!authToken) {
                throw new Error("No token found in localStorage.");
            }
            const {token} = JSON.parse(authToken);


            const response = await axios.delete(`/api/lessons/${lessonsId}/tests`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                data: {
                    testId: testId,
                },
            });


            if (response.data && response.data.success) {
                thunkAPI.dispatch(getLessonsTest({lessonsId}))
            }

            return response.data;
        } catch (e) {
            return thunkAPI.rejectWithValue("error");
        }
    }
);
